import { atom } from 'jotai'

import type { PublicAccount } from '@/types/generated/common/account'
import { TradeVenue } from '@/types/generated/common/types'

export const apiCredentialsFormStateAtom = atom<{
  apiKey: string
  apiSecret: string
  accountName: string
  tradeVenue: TradeVenue
  editingAccount: PublicAccount | null
}>({
  apiKey: '',
  apiSecret: '',
  accountName: '',
  tradeVenue: TradeVenue.TRADE_VENUE_DERIBIT,
  editingAccount: null,
})
